// extracted by mini-css-extract-plugin
export default {"btnpwd":"ac8aeef24d"};